//
// Rule.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./RuleContext";

var Rule = createModule("commons::Rule", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        setBoundContext: [0,1],
        clone: [1],
        run: [0,1,1],
        getBoundContext: [1],
    },
    ,
    ,
]);
export default Rule;
